/* eslint-disable prettier/prettier */
import {
  Bench2Practice,
  ModernaAtlas,
  ModernaLogo,
  ModernaLogoWhite,
  MresviaLogo,
  MrnaAccess,
  Spikevax,
  SpikevaxElasomeran,
  SpikevaxKr,
  SpikevaxModerna,
  SpikevaxNavbar,
  SpikevaxRegistered,
  SpikevaxRegisteredFrench
} from "./assets";
import { MNexSpikeLogo } from "./assets/mnexspike-logo";

export const BRAND_LOGOS = {
  "bench-2-practice": Bench2Practice,
  "mnexspike-logo": MNexSpikeLogo,
  "moderna-atlas": ModernaAtlas,
  "moderna-logo-white": ModernaLogoWhite,
  "moderna-logo": ModernaLogo,
  "mresvia-logo": MresviaLogo,
  "mrna-access": MrnaAccess,
  "spikevax-elasomeran": SpikevaxElasomeran,
  "spikevax-kr": SpikevaxKr,
  "spikevax-moderna": SpikevaxModerna,
  "spikevax-navbar": SpikevaxNavbar,
  "spikevax-registered-french": SpikevaxRegisteredFrench,
  "spikevax-registered": SpikevaxRegistered,
  "spikevax": Spikevax
};
